import { BaseService } from './base';
import { ApiRequest } from '../lib/request';
import type { ApiResponse } from '../lib/response';
import type { AxiosProgressEvent } from 'axios';
import { Upload } from '../models/upload';

export class UploadService extends BaseService<Upload> {
  override model = Upload;
  override modelName = 'upload';
  override modelLabel = 'Upload';

  async upload(
    { file, params = {} }: { file: File; params?: Record<string, any> },
    options?: { onUploadProgress?: (progressEvent: AxiosProgressEvent) => void },
  ): Promise<ApiResponse<Upload>> {
    const formData = new FormData();
    formData.append('photo', file);

    for (const [key, value] of Object.entries(params)) {
      formData.append(key, value);
    }

    const request = new ApiRequest({
      method: 'POST',
      url: this.modelBaseUrl,
      data: formData,
      onUploadProgress: options?.onUploadProgress,
    });

    return await this.requestItem(request, Upload);
  }
}
